import React from 'react';
import DeviceContext, { DeviceContextType } from './context/device';
import DirectionContext, { DirectionContextType } from './context/direction';
import MarketContext, { MarketContextValue } from './context/market';
import UserContext, { UserContextType } from './context/user';
import ButtonContext, { ButtonType } from './context/button';

import Theme, { ValidThemes } from './theme';

export type ComponentConfigurationType = {
  device?: DeviceContextType;
  children?: React.ReactNode;
  market?: MarketContextValue;
  country?: string;
  language?: string;
  direction?: DirectionContextType;
  user?: UserContextType;
  themeName?: ValidThemes;
  uppercaseButtons?: ButtonType;
};

function ComponentConfiguration(props: ComponentConfigurationType) {
  const {
    device = {
      platform: null,
      gpb_supported: false,
    },
    direction = 'ltr',
    market = {
      market: null,
      country: null,
      language: null,
      isEvergreen: true,
    },
    user = {
      ineligibility_flag: null,
      authenticated: false,
      eligibility: 'unknown',
    },
    themeName,
    children,
    uppercaseButtons,
  } = props;

  return (
    <Theme themeName={themeName}>
      <DeviceContext.Provider value={device}>
        <DirectionContext.Provider value={direction}>
          <MarketContext.Provider value={market}>
            <UserContext.Provider value={user}>
              <ButtonContext.Provider value={uppercaseButtons}>
                {children}
              </ButtonContext.Provider>
            </UserContext.Provider>
          </MarketContext.Provider>
        </DirectionContext.Provider>
      </DeviceContext.Provider>
    </Theme>
  );
}

export default ComponentConfiguration;
